module.exports = __webpack_public_path__ + "media/img/abhaken-2f6428d153ed6fcfc1731ea947d37a42.svg";